import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { ethers } from "ethers";
import { erc20Abi } from "@/abi";
import { useSmartWallet } from "./SmartWallet";

interface IUSDTContext {
  usdtBalance: number;
  usdtBalanceInInr: number;
  isLoading: boolean;
  error: Error | null;
  hasFetched: boolean;
  refreshUSDT: () => Promise<void>;
}

const initialUSDTContext: IUSDTContext = {
  usdtBalance: 0,
  usdtBalanceInInr: 0,
  isLoading: false,
  error: null,
  hasFetched: false,
  refreshUSDT: async () => undefined,
};

const ethersProvider = new ethers.providers.JsonRpcProvider(
  import.meta.env.VITE_RPC_URL,
);

const readUSDTContract = async (functionName: string, args: any[] = []) => {
  try {
    const contractInstance = new ethers.Contract(
      import.meta.env.VITE_USDT_CONTRACT_ADDRESS,
      erc20Abi,
      ethersProvider,
    );
    const result = await contractInstance[functionName](...args);
    console.log(result, "--", functionName);
    return result;
  } catch (err: any) {
    console.log("check errrrrr---", functionName, args, err);
  }
};

const USDTContext = createContext(initialUSDTContext);

export const USDTContextProvider = ({ children }: { children: ReactNode }) => {
  const { smartWalletAddress } = useSmartWallet();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [hasFetched, setHasFetched] = useState(false);
  const [usdtBalance, setUsdtBalance] = useState(
    initialUSDTContext.usdtBalance,
  );

  const readUSDT = async () => {
    setIsLoading(true);
    try {
      const balance = await readUSDTContract("balanceOf", [smartWalletAddress]);

      if (balance) {
        setUsdtBalance(Number(ethers.utils.formatUnits(balance, 6)));
        setError(null);
        setHasFetched(true);
      } else {
        setError(new Error("USDC balance was undefined."));
        console.error("USDC balance undefined.");
      }
    } catch (error) {
      setError(error as Error);
      console.error("readingUSDT in useMerchant", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (smartWalletAddress) void readUSDT();
  }, [smartWalletAddress]);

  return (
    <USDTContext.Provider
      value={{
        usdtBalance,
        usdtBalanceInInr: usdtBalance * 82.91,
        isLoading,
        error,
        hasFetched,
        refreshUSDT: readUSDT,
      }}>
      {children}
    </USDTContext.Provider>
  );
};

export const useUSDT = () => useContext(USDTContext);
